import { api } from 'restaurantAdmin/api';
import type {
  OperaCandidatesResponse,
  OperaCoversDTO,
  OperaGuestProfileDTO,
  OperaHotelGuestDTO,
  OperaLinkDTO,
  OperaMatchAttemptDTO,
  OperaModeDTO,
  OperaSyncFailureDTO,
} from './types';

export interface SearchOperaCandidatesParams {
  query: string;
}

export const getOperaCandidates = (
  restaurantId: string,
  reservationId: string,
  searchParams?: SearchOperaCandidatesParams,
): Promise<OperaCandidatesResponse> => {
  const query = searchParams
    ? `?${new URLSearchParams({ ...searchParams })}`
    : '';

  return api.get(
    `/restaurants/${restaurantId}/opera/reservations/${reservationId}/candidates${query}`,
  );
};

export const linkOperaReservation = (
  restaurantId: string,
  reservationId: string,
  operaReservationId: string,
): Promise<OperaLinkDTO> =>
  api.post(
    `/restaurants/${restaurantId}/opera/reservations/${reservationId}/link`,
    { operaReservationId },
  );

export const rejectOperaMatch = (
  restaurantId: string,
  reservationId: string,
  operaReservationId: string,
): Promise<void> =>
  api.post(
    `/restaurants/${restaurantId}/opera/reservations/${reservationId}/reject`,
    { operaReservationId },
  );

export const refreshOperaLink = (
  restaurantId: string,
  reservationId: string,
): Promise<OperaLinkDTO> =>
  api.post(
    `/restaurants/${restaurantId}/opera/reservations/${reservationId}/refresh`,
  );

export const getOperaCovers = (
  restaurantId: string,
  date: string,
): Promise<OperaCoversDTO> =>
  api.get(`/restaurants/${restaurantId}/opera/covers?date=${date}`);

export const getOperaSyncFailures = (
  restaurantId: string,
): Promise<OperaSyncFailureDTO[]> =>
  api.get(`/restaurants/${restaurantId}/opera/sync-failures`);

export const getOperaMatchAttempts = (
  restaurantId: string,
): Promise<OperaMatchAttemptDTO[]> =>
  api.get(`/restaurants/${restaurantId}/opera/match-attempts`);

export const getOperaMode = (restaurantId: string): Promise<OperaModeDTO> =>
  api.get(`/restaurants/${restaurantId}/opera/mode`);

export const getOperaHotelGuests = (
  restaurantId: string,
  from: string,
  to: string,
): Promise<OperaHotelGuestDTO[]> =>
  api.get(
    `/restaurants/${restaurantId}/opera/links?${new URLSearchParams({ from, to })}`,
  );

export const getOperaGuestProfile = (
  restaurantId: string,
  guestId: string,
): Promise<{ data: OperaGuestProfileDTO | null }> =>
  api.get(`/restaurants/${restaurantId}/opera/guests/${guestId}/profile`);
